import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const TokenInstanceFields = ({
  inputInstanceId,
  setInputInstanceId,
  inputToken,
  setInputToken,
  instanceId,
  token,
  editMode,
  setEditMode,
  onSave,
  onReset,
}) => {
  const [isSaved, setIsSaved] = useState(false);
  const isSaveDisabled = !inputInstanceId.trim() || !inputToken.trim();

  useEffect(() => {
    setIsSaved(false);
  }, [editMode, inputInstanceId, inputToken]);

  const handleSave = () => {
    if (isSaveDisabled) return;
    onSave();
    setIsSaved(true);
    setEditMode(false);
  };

  return (
    <motion.div
      className="flex flex-col mb-6"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
      <div className="flex flex-col mb-6">
        <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg flex flex-col md:flex-row md:items-center gap-4 text-gray-900">
          <div className="flex-1 flex gap-3">
            <div className="flex flex-col flex-1">
              <label className="mb-1 text-xs font-semibold text-gray-600">
                Instance ID
              </label>
              <input
                className={`w-full rounded px-3 py-2 border ${
                  editMode ? "bg-white border-gray-200" : "bg-gray-100 border-gray-200"
                } text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#01CC54]/20 focus:border-[#01CC54]`}
                placeholder="instance123"
                value={editMode ? inputInstanceId : instanceId}
                onChange={(e) => setInputInstanceId(e.target.value)}
                disabled={!editMode}
                autoComplete="off"
              />
            </div>
            <div className="flex flex-col flex-1">
              <label className="mb-1 text-xs font-semibold text-gray-600">
                Token
              </label>
              <input
                className={`w-full rounded px-3 py-2 border ${
                  editMode ? "bg-white border-gray-200" : "bg-gray-100 border-gray-200"
                } text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#01CC54]/20 focus:border-[#01CC54]`}
                placeholder="Token"
                value={editMode ? inputToken : token}
                onChange={(e) => setInputToken(e.target.value)}
                disabled={!editMode}
                autoComplete="off"
              />
            </div>
          </div>

          <div className="flex gap-2 mt-3 md:mt-0">
            <button
              className={`bg-[#048AAD] hover:bg-[#048AAD]/90 text-white font-semibold px-4 py-2 rounded border border-transparent transition ${
                isSaveDisabled ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={handleSave}
              disabled={isSaveDisabled}
              type="button"
            >
              Save
            </button>
            <button
              className="bg-gray-100 text-gray-700 font-semibold px-4 py-2 rounded border border-gray-200 hover:bg-gray-200 transition"
              onClick={onReset}
              type="button"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default TokenInstanceFields;
